import React from 'react';
import PropTypes from 'prop-types';
import css from './InstructionsToUse.module.css';
import ReactPlayer from 'react-player';

const InstructionsToUse = ({ content }) => {
    const { text, video } = typeof content === 'object' ? content : { text: content, video: null }; // to support pre    
    return (
        <div className={css.panel}>
            <h4 className={css.heading}>Instructions to Use</h4>
            <div className={css.content} dangerouslySetInnerHTML={{ __html: text }} />
            {video?.playback_url && (
                <div className={css.video}>
                    <ReactPlayer 
                    url={video?.playback_url}
                    controls
                    width={'100%'}
                    height={414}
                    style={{ borderRadius: 8, background: '#000' }}
                    />
                </div>
            )}
        </div>
    );
};

InstructionsToUse.propTypes = {
    content: PropTypes.string.isRequired,
};

export default InstructionsToUse; 